<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
    </div>
    <form @submit.prevent>
      <div class="row">
        <div class="col-12">
          <select-item :validator="$v.recipient"
            :items="formattedRecipients"
            placeholder="Select a Recipient"
            placeholderEmpty="No recipients found"
            :isLoading="isLoadingRecipients" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <fg-input type="number"
            placeholder="Number of Licenses to Transfer"
            :class="{ 'form-group--error': $v.amount.$error }"
            v-model="$v.amount.$model">
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
          <textarea placeholder="Notes"
            class="form-control"
            v-model="notes" />
          </div>
        </div>
      </div>
      <div class="text-left">
        <p-button type="info"
          :loading="isLoading"
          @click.native.prevent="transferLicenses">
          Confirm
        </p-button>
      </div>
      <div class="clearfix"></div>
    </form>
  </div>
</template>

<script>
import SelectItem from '../Inputs/SelectItem.vue';
import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  name: 'TransferForm',
  components: {
    SelectItem
  },
  props: {
    pool: Object
  },
  data() {
    return {
      recipient: "",
      recipients: [],
      amount: null,
      notes: "",
      isLoading: false,
      isLoadingRecipients: false,
      successMessage: ""
    }
  },
  validations: {
    recipient: { required },
    amount: { required }
  },
  created() {
    this.fetchRecipients();
  },
  methods: {
    async transferLicenses() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please provide a recipient and an amount.')
        return;
      }

      this.isLoading = true;
      try {
        await ziperase.transferLicenseToPool(this.pool.id, {
          recipient_pool_id:  this.recipient.id,
          count:              this.amount,
          notes:              this.notes
        });
        this.$emit('hasUpdate');
        this.$store.dispatch('licensePool/refetchTransactions');
        this.successMessage = `Success! Transferred ${this.amount} licenses to ${this.recipient.name}.`;
        this.resetForm();
      } catch (err) {
        notify().error('Failed to transfer licenses.');
      }
      this.isLoading = false;
    },
    async fetchRecipients() {
      this.isLoadingRecipients = true;
      try {
        const response = await ziperase.fetchRecipients(this.pool.id);
        this.recipients = response.data;
      } catch (error) {
        notify().error('Failed to retrieve recipients.');
      }
      this.isLoadingRecipients = false;
    },
    resetForm() {
      this.recipient = "";
      this.amount = null;
      this.notes = "",
      this.$v.$reset();
    },
    recipientName(pool) {
      let name = `${pool.license_type.product.name}: ${pool.license_type.name}`;
      if (this.groupNameMap[pool.group_id]) {
        name = `${name} - ${this.groupNameMap[pool.group_id]}`;
      }
      return name;
    }
  },
  computed: {
    ...mapGetters('group', ['groupNameMap']),
    formattedRecipients() {
      if (!this.recipients) {
        return [];
      }

      return this.recipients.map(pool => {
        return {
          id:   pool.id,
          name: this.recipientName(pool)
        }
      });
    }
  }
};
</script>
